import React, { Fragment, useState } from 'react';

import { Box } from '@rbilabs/universal-components';
import { format } from 'date-fns';
import { useStoreContext } from 'features/store';
import { useStoreAvailabilityFns } from 'features/store/hooks/use-store-availability-fns';
import { getStoreLocalTime } from 'features/store/utils';

import { Typography } from 'components/ui';
import useInterval from 'hooks/use-interval';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { EnvItem, ServiceModeItem } from '../components/env-item';
import { EnvList } from '../components/env-list';
import { HiddenSection } from '../components/hidden-section';

const StoreTime = () => {
  const [state, setState] = useState({
    deviceTime: format(Date.now(), "yyyy-MM-dd'T'HH:mm:ss.sssXXX"),
    storeTime: getStoreLocalTime(),
  });
  useInterval(() => {
    setState({
      deviceTime: format(Date.now(), "yyyy-MM-dd'T'HH:mm:ss.sssXXX"),
      storeTime: getStoreLocalTime(),
    });
  }, 5000);

  return (
    <>
      <EnvItem envKey="Device Local Time" value={state.deviceTime} />
      <EnvItem envKey="Store Local Time" value={state.storeTime} />
    </>
  );
};

export const StoreDiagnostics = () => {
  const enableInternalDiagnosticTools = useFlag(LaunchDarklyFlag.ENABLE_INTERNAL_DIAGNOSTIC_TOOLS);

  const { noStoreSelected, store } = useStoreContext();
  const { getStoreServiceModeStatuses } = useStoreAvailabilityFns();
  const storeServiceModeStatuses = getStoreServiceModeStatuses(store, getStoreLocalTime());

  if (!enableInternalDiagnosticTools) {
    return null;
  }

  const serviceModeStatus: Record<string, any> = {};

  storeServiceModeStatuses.forEach(({ serviceMode, ...details }) => {
    serviceModeStatus[serviceMode] = details;
  });

  return (
    <>
      <Typography pt="$4" variant="headerThree">
        Store Info
      </Typography>
      {!noStoreSelected ? (
        <>
          <EnvItem envKey="StoreId" value={store.number} />
          <StoreTime />
          <HiddenSection
            title="Service Modes Availability"
            content={
              <Box>
                <EnvList
                  data={serviceModeStatus}
                  renderItem={(key, value) => <ServiceModeItem envKey={key} value={value} />}
                />
              </Box>
            }
          />
          <HiddenSection
            title="Service Modes Hours"
            content={
              <>
                {store.serviceModeHours?.map(smh => (
                  <Fragment key={smh.serviceMode}>
                    <EnvItem envKey={`${smh.serviceMode}_OPEN`} value={smh.open} />
                    <EnvItem envKey={`${smh.serviceMode}_CLOSE`} value={smh.close} />
                  </Fragment>
                ))}
              </>
            }
          />
        </>
      ) : (
        <Box>No store selected</Box>
      )}
    </>
  );
};
